import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { SharedModule } from './shared/shared.module';
import { FormsModule } from '@angular/forms';
import { environment } from '../environments/environment';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from 'ngx-spinner';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { PagesModule } from './views/pages/pages.module';
import { ModalModule, BsModalRef } from 'ngx-bootstrap/modal';
import {AuthGuard} from './core/auth.guard';
import { ChartsModule } from 'ng2-charts';

@NgModule({
    imports: [
        BrowserModule,
        AppRoutingModule,
        CoreModule,
        SharedModule,
        PagesModule,
        FormsModule,
        NgbModule,
        ModalModule.forRoot(),
        BrowserAnimationsModule,
        NgxSpinnerModule,
        ToastrModule.forRoot(),
        ChartsModule
    ],
    declarations: [AppComponent],
    providers: [BsModalRef, { provide: 'baseUrl', useValue: environment.baseUrl }, AuthGuard],
    bootstrap: [AppComponent],
})
export class AppModule {}
